import { Injectable } from "@angular/core";
import { IID_RISORSE_PERMESSO_PUBBLICO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "@ep-om/project/state/interfaceDataModel";
import { IIDRisorsePermessoPubblicoStore } from "./iidRisorsePermessoPubblico.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.RISORSE_PERMESSO_PUBBLICO)
export class IIDRisorsePermessoPubblicoQuery extends AbstractInterfaceDataQuery<IID_RISORSE_PERMESSO_PUBBLICO> {
  constructor(protected store: IIDRisorsePermessoPubblicoStore) {
    super(store);
  }
}
